<template>
  <section class="topsection">
    <div class="container">
      <div class="row">
        <div class="col-sm-6">
          <div
            class="mainimg"
            :style="{
              backgroundImage: `url(${mainImg})`,
            }"
          ></div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-12 order-2 order-sm-1"> <!-- 채림 : 모바일에서 2번째, pc에서 1번째로 보임-21.06.11. -->
              <h1 class="tit-st mt-4 white-space--pre">{{ product.productsKoreanName }}</h1>
              <p class="txt-st02 mb-2  white-space--pre">{{ product.productsEnglishName }}</p>
            </div>
            <div class="col-sm-12 order-1 order-sm-2"> <!-- 채림 : 모바일에서 1번째, pc에서 2번째로 보임-21.06.11. -->
              <div class="thumbWrap"> <!-- 채림 : 썸네일 가운데정렬용 div추가-21.06.11. -->
                <thumbnail-section
                  :thumbnail="thumbnail"
                  :mainImg="mainImg"
                  v-for="(thumbnail, idx) in product.productsImageUrl"
                  :key="idx"
                  @change-main-img="changeMainImg"
                />
              </div>
            </div>
            <div class="col-sm-12 order-3"> <!-- 채림 : 모바일에서 3번째로 보임-21.06.11. -->
              <p class="txt-st03 mt-2 mb-2 white-space--pre">{{ product.productsKeyPoint }}</p>
            </div>
          </div>
          <div class="row infoWrap"> <!-- 채림 : 모바일에서 info 배경용 div 추가-21.06.11. -->
            <div class="col-sm-12">
              <dl class="info pt-5">
                <dt>용량 및 중량</dt>
                <dd class="white-space--pre">{{ product.productsVolume }}</dd>
                <dt>기능성 화장품 유무</dt>
                <dd class="white-space--pre">{{ product.productsFunctional }}</dd>
                <dt>피부타입</dt>
                <dd class="white-space--pre">{{ product.skinType }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ThumbnailSection from './ThumbnailSection.vue';

export default {
  name: 'ProductMainInfo',
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ThumbnailSection,
  },
  watch: {
    product: {
      deep: true,
      handler(v) {
        if (v.productsImageUrl[0] !== this.mainImg) {
          // eslint-disable-next-line prefer-destructuring
          this.mainImg = v.productsImageUrl[0];
        }
      },
    },
  },
  created() {
    // eslint-disable-next-line prefer-destructuring
    this.mainImg = this.product.productsImageUrl[0];
  },
  data() {
    return {
      mainImg: '',
    };
  },
  methods: {
    changeMainImg(img) {
      this.mainImg = img;
    },
  },
};
</script>

<style lang="scss" scoped> // 채림 : 모바일에서의 margin-bottom 제거-21.06.11.
  .txt-st02.mb-2{
    @media (max-width: $mobile-size) {
      margin-bottom: 0 !important;
    }
  }
</style>
